import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  Image,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import fontBold from "./fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "./fonts/NotoSansTamil-Regular.ttf";
import { BsTransparency } from "react-icons/bs";

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // getMonth() returns month from 0-11
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

Font.register({
  family: "fontBold",
  fonts: [{ src: fontBold, fontStyle: "normal", fontWeight: "bold" }],
});
Font.register({
  family: "fontRegular",
  fonts: [{ src: fontRegular, fontStyle: "normal", fontWeight: "normal" }],
});
const styles = StyleSheet.create({

  halfPage: {
    flex: 1,
  },
  dividerLine: {
    height: 1,
    backgroundColor: "#4535C1",
    marginVertical: 5,
  },
  normalText: {
    fontFamily: "fontRegular",
    fontWeight: "normal",
    margin: 10,
  },
  boldText: {
    fontFamily: "fontBold",
    fontWeight: "bold",
    fontSize: 10,
  },
  boldTextone: {
    fontFamily: "fontBold",
    fontWeight: "bold",
    fontSize: 12,
    textAlign: "center",
    marginTop: 5,
  },
  page: {
    flexDirection: "row",
    backgroundColor: "#fff",
    padding: 0,
  },

  header: {
    fontFamily: "fontRegular",
    fontSize: 8,
  },
  section: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
    marginBottom: 500,
    color: "#4535C1",
  },
  dupe: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    //padding: 10,
    borderColor: "#4535C1",
    letterSpacing: 1,
    //marginBottom: 00,
    color: "#4535C1",
  },
  godtitle: {
    fontSize: 8,
    padding: 5,
    textAlign: "center",
  },
  godtitles: {
    position: "absolute",
    justifyContent: "start",
    alignItems: "start",
    textAlign: "start",
    right: 140,
    bottom: 50,
    top: 1,
    left: 300,
    padding: 10,
    color: "#4535C1",
    fontSize: 70,
    fontWeight: "bold",
  },
  font: {
    fontFamily: "fontRegular",
  },
  red: {
    color: "red",
  },
  storename: {
    textAlign: "center",
    fontFamily: "fontBold",
    fontSize: 12,
    letterSpacing: 1,
    fontWeight: "bold",
  },
  storehead: {
    textAlign: "center",

    fontSize: 8,
    letterSpacing: 1,
  },

  table: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "column",
    width: "100%",
    borderBottom: 1,
    borderTop: 1,
    fontSize: 9,
    borderColor: "#4535C1",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "center",
  },
  tableRow1: {
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingRight: 30,
  },
  company: {
    width: "100%",
    fontFamily: "fontRegular",
    textAlign: "center",
    alignItems: "center",
  },
  dateCell: {
    width: "100%",
    padding: 7,
    fontSize: 8.5,
  },
  pad: {
    paddingVertical: 3,
  },
  tab: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 10,
    fontSize: 8,
  },
  pawnAmt: {
    textAlign: "right",
  },
  customerdetail: {
    paddingTop: 10,
    paddingHorizontal: 7,
    display: "flex",
    fontSize: 7.5,
  },
  details1: {
    paddingVertical: 6,
    display: "flex",
    flexDirection: "row",
  },
  details: {
    paddingVertical: 6,
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
  details2: {
    flexDirection: "row",
    fontSize: 7.6,
  },
  state: {
    width: "31.5%",
    fontFamily: "fontBold",
    fontWeight: "bold",
  },
  customtab: {
    display: "flex",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingVertical: 4,
  },
  jewelprice: {
    paddingVertical: 10,
  },
  row: {
    flexDirection: "row",
    marginBottom: 5,
  },
  footer: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    color: "#4535C1",
  },
  time: {
    width: "45%",
    alignItems: "center",

    fontSize: 8,
    fontFamily: "fontRegular",

  },
  footerdesc: {
    padding: 12,
    border: 1,
    marginHorizontal: 3,
    borderRadius: 8,
    fontSize: 8,
    paddingHorizontal: 10,
    width: "70%",
    borderColor: "#4535C1",

  },
  origialdesc: {
    width: "100%",
    padding: 12,
    border: 1,
    marginHorizontal: 2,
    borderRadius: 8,
    fontSize: 8,
    borderColor: "#4535C1",
  },
  phone: {
    width: "55%",
    alignItems: "center",
    fontSize: 8,
    fontFamily: "fontRegular",
  },
  ph: {
    marginVertical: 10,
  },
  none: {
    display: "none",
  },
  line: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    color: "#4535C1",
    marginTop: 0,
  },
  termsTitle: {
    fontSize: 10,
    fontFamily: "fontRegular",
  },
  termlist: {
    fontSize: 9,
    paddingHorizontal: 22,
  },
  termpoint: {
    paddingVertical: 25,
  },
  billcreate: {
    fontSize: 8,
  },
  padmac: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 40,
    bottom: 15,
    padding: 15,
    fontSize: 12,
    fontWeight: "bold",
  },
  paidStamp: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 15,
    bottom: 50,
    padding: 10,
    borderWidth: 2,
    borderColor: "#4535C1",
    borderRadius: 5,
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  paidText: {
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  divider: {
    width: "100%",
    height: 1.5,
    backgroundColor: "#4535C1",
    marginVertical: 5,
  },
  dateText: {
    color: "#C40C0C",
    fontSize: 14,
    fontWeight: "bold",
  },

  tableContent: {
    marginVertical: "550px",
    margin: 8,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
  },
  image: {
    width: 100, // Adjust width as needed
    height: 100, // Adjust height as needed
    resizeMode: "contain", // Keeps aspect ratio
    marginBottom: 1,
  },
  headright: {
    paddingLeft: 25,
  },
  headdivright: {
    fontSize: 8,
    //flexDirection: "row",
    // justifyContent: "flex-start",
  },
  tamilTable: {
    margin: 20,
    border: '1pt solid #4535C1',

  },
  tamilTableRowHeader: {
    flexDirection: 'row',
    borderBottom: '1pt solid #4535C1',
    paddingVertical: 5,

  },
  tamilTableRow: {
    flexDirection: 'row',

    paddingVertical: 5,
  },
  tamilTableRowTotal: {
    flexDirection: 'row',
    borderTop: '1pt solid #4535C1',
    paddingVertical: 5,
    marginTop: 4,
    paddingTop: 3,
  },
  tamilCellLeft: {
    width: '50%',
    fontSize: 10,
    paddingLeft: 5,
  },
  tamilCellRight: {
    width: '50%',
    textAlign: 'right',
    fontSize: 10,
    paddingRight: 5,
  },
  tamilCellLeftBold: {
    width: '50%',
    fontSize: 10,
    fontWeight: 'bold',
    paddingLeft: 5,
  },
  tamilCellRightBold: {
    width: '50%',
    textAlign: 'right',
    fontSize: 10,
    fontWeight: 'bold',
    paddingRight: 5,
  },
  logoContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  logoImage: {
    width: 80,
    height: 50,
    //objectFit: "contain",
  },
  tableCell: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#4535C1",
  }
});
const Receipt = ({ data }) => {
  console.log("data", data);

  const formattedDate = formatDate(data.interest_receive_date);
  const data1 = {
    entries: [
      { label: "அசல்", amount: "50,000" },
      { label: "வட்டி", amount: "2,000" },
      { label: "இதர கட்டணங்கள்", amount: "100" },
    ],
    total_amount: "52,100"
  };

  return (
    <View style={styles.dupe}>
      <View style={styles.font}>
        <View style={styles.table}>
          <View style={styles.tableCell}>
            <Text style={styles.pad}>
              <Text style={styles.normalText}>BPL NO: 06/2017-2018</Text>
            </Text>
            <View style={styles.headdivright}>
              <Text> Ph : 98421 84070 </Text>
              <Text style={styles.headright}>9042222080 </Text>
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.company}>
              <View style={styles.logoContainer}>
                <Image src="/logo192.png" style={styles.logoImage} />
              </View>
              <Text style={styles.storename}>செல்லம் பைனான்ஸ்</Text>
              <Text style={{ marginTop: 3, fontSize: 8 }}>
                358-1 வடக்கு மாசி வீதி, மதுரை-625001
              </Text>
              <Text></Text>
              <Text></Text>
              <Text style={styles.boldText}>
                (கடை வேலை நேரம்  9:00 AM to 6:00 PM (திங்கள்  to
                    சனிக்கிழமை வரை  ))
              </Text>
              <Text style={styles.boldTextone}>வட்டி  ரசீது </Text>
            </View>
          </View>
          <View style={styles.tableRow1}>
            <View style={styles.dateCell}>
            </View>
          </View>
        </View>
        <View style={styles.customerdetail}>
          <View style={styles.details}>
            <Text style={styles.state}>1.வாடிக்கையாளர் எண்: </Text>
            <Text> {data.receipt_no} </Text>
          </View>
          <View style={styles.details}>
            <Text style={styles.state}>2.அடகு எண்: </Text>
            <Text> {data.receipt_no} </Text>
          </View>
          <View style={styles.details}>
            <Text style={styles.state}>3.பெயர்  : </Text>
            <Text> {data.name} </Text>
          </View>
          <View style={styles.details}>
            <Text style={styles.state}>4.வட்டி பெறும் தேதி:</Text>
            <Text> {formattedDate} </Text>
          </View>

        </View>
        <View style={styles.tamilTable}>
          <View style={styles.tamilTableRowHeader}>
            <Text style={[styles.tamilCellLeft, styles.boldText]}>விவரங்கள்</Text>
            <Text style={[styles.tamilCellRight, styles.boldText]}>தொகை </Text>
          </View>

          <View style={styles.tamilTableRow}>
            <Text style={styles.tamilCellLeft}>வட்டி பெறுதல்</Text>
            <Text style={styles.tamilCellRight}>{data.interest_income}</Text>
          </View>

          <View style={styles.tamilTableRowTotal}>
            <Text style={[styles.tamilCellLeftBold, styles.boldText]}> மொத்த தொகை  </Text>
            <Text style={[styles.tamilCellRightBold, styles.boldText]}>{data.interest_income}</Text>
          </View>
        </View>
        <View style={styles.footer}>
          <View style={styles.time}>
            <View style={styles.termpoint}>
              <Text style={styles.boldText}>பணம் செலுத்துபவரின் கையொப்பம் </Text>
            </View>
          </View>
          <View style={styles.phone}>
            <View style={styles.termpoint}>
              <Text style={styles.boldText}>செல்லம் பைனான்ஸ் </Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  )
};

const ReceiptPDF = ({ data }) => {

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={styles.halfPage}>
          <Receipt data={data} />
        </View>
        <View style={styles.dividerLine} />
        <View style={styles.halfPage}>
          <Receipt data={data} />
        </View>
      </Page>
    </Document>
  );
};

export default ReceiptPDF;